import { useParams, useSearchParams } from "react-router";
import { usePageTitle } from "@shared/client/view";
import { Button } from "@shared/components/ui/button";
import { useLocale, useT } from "@shared/client/locale";
import { LEGAL_ENTITY, legalUrl } from "@shared/lib/legal";

/**
 * Désinscription des e-mails de prospection de Hune : un bouton, aucune
 * question, confirmation immédiate. La page ne lit pas la base : elle ne dit
 * jamais si une adresse y figure. Publique, sans session.
 */
export default function StopPage() {
  const t = useT();
  const locale = useLocale();
  const copy = t.auth.stop;
  usePageTitle(t.auth.pageTitles.stop);
  const { token = "" } = useParams();
  const [params] = useSearchParams();
  const done = Boolean(params.get("done"));

  return (
    <main className="min-h-screen bg-background">
      <section className="mx-auto w-full max-w-[560px] px-5 py-16">
        <h1 className="m-0 font-serif text-[clamp(28px,4vw,36px)] leading-[1.1] font-normal tracking-[-0.02em]">
          {done ? copy.done : copy.title}
        </h1>
        {done ? (
          <p className="mt-4 text-[15px] leading-relaxed text-muted-foreground">{copy.doneBody(LEGAL_ENTITY.brand)}</p>
        ) : (
          <>
            <p className="mt-4 text-[15px] leading-relaxed text-muted-foreground">{copy.body(LEGAL_ENTITY.brand)}</p>
            {/* Formulaire natif : l'API répond par une redirection vers ?done=1. */}
            <form action={`/api/public/prospection/stop/${encodeURIComponent(token)}`} className="mt-7" method="post">
              <input name="confirm" type="hidden" value="1" />
              <Button size="lg" type="submit">
                {copy.submit}
              </Button>
            </form>
          </>
        )}
        <p className="mt-10 text-[13px] leading-relaxed text-muted-foreground">
          {copy.question}{" "}
          <a className="text-primary hover:underline" href={`mailto:${LEGAL_ENTITY.email}`}>
            {LEGAL_ENTITY.email}
          </a>{" "}
          ·{" "}
          <a className="text-primary hover:underline" href={legalUrl("privacy", locale)}>
            {copy.privacy}
          </a>
        </p>
      </section>
    </main>
  );
}
